import React from 'react';
import { Message } from '@weezevent/nacre';
import ZonePicker from './ZonePicker';
import css from './manual-modal.module.css';
import { useTranslation } from 'react-i18next';
import LoadingCard from '../../../../../../components/loadingCard';

export default function ModalMap({
    availability,
    inventories,
    categories,
    currentInventory,
    selectedZone,
    setPreviousZone,
    previousZone,
    showSeats,
    setShowSeats,
    popUp,
    form,
    setPopUp,
    onBackToRoot,
    hoveredZone,
    onSelectZone,
    setHoveredZone,
    loading,
    loadingZones,
    isBooking,
    sync,
    preview,
    currency,
    rates,
    selectedRates,
    onSelectRate,
    onAddAttendee,
    onSetRates
}) {
    const { t } = useTranslation();

    if (!loading && !rates.length) {
        return <>{t('ticket.partners.batch.rate.noRates')}</>;
    }

    if (loading || loadingZones || isBooking || !categories.length) {
        return <LoadingCard loading />;
    }

    return (
        <>
            <ZonePicker
                zones={availability}
                inventories={inventories}
                categories={categories}
                currentInventory={currentInventory}
                selectedZone={selectedZone}
                previousZone={previousZone}
                setPreviousZone={setPreviousZone}
                popUp={popUp}
                form={form}
                onBackToRoot={onBackToRoot}
                showSeats={showSeats}
                setShowSeats={setShowSeats}
                setPopUp={setPopUp}
                hoveredZone={hoveredZone}
                onSelectZone={onSelectZone}
                setHoveredZone={setHoveredZone}
                loading={loading}
                loadingZones={loadingZones}
                isBooking={isBooking}
                sync={sync}
                preview={preview}
                currency={currency}
                rates={rates}
                selectedRates={selectedRates}
                onSelectRate={onSelectRate}
                onAddAttendee={onAddAttendee}
                onSetRates={onSetRates}
            />

            <Message className={css['seated-map-container-tips']} mini title={t('attendees.addAttendees.withSeats.modalTipsTitle')} type="tips">
                {t('attendees.addAttendees.withSeats.modalTips')}
            </Message>
        </>
    );
}
